import LivePostsPartial from "../../partials/campaign/live-posts.partial";

export default function LivePostsScreen() {
  return <LivePostsPartial />;
}
